export const DataTable = ({ cols, rows, id, bold = 0 }) => (
  <div className="overflow-x-auto" data-testid={`lam-table-${id}`}>
    <table className="w-full min-w-[520px] border-collapse text-left text-sm">
      <thead><tr className="border-b border-[#121110]/25">{cols.map((c) => <th key={c} className="py-3 pr-4 font-mono text-xs font-normal uppercase tracking-[0.1em] text-[#5A544C]">{c}</th>)}</tr></thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i} className="border-b border-[#121110]/10">
            {r.map((v, k) => <td key={k} className={`py-2.5 pr-4 tabular-nums ${k === bold ? "font-display font-bold text-[#9A5326]" : ""}`}>{v}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
